import axiosInstance from '../Lib/axios';
import {
  ADD_COMMERCIAL_PROPOSAL,
  UPDATE_COMMERCIAL_QUOTE,
  UPDATE_COMMERCIAL_QUOTE_FAILED,
  UPDATE_COMMERCIAL_PROPOSAL,
  UPDATE_COMMERCIAL_PROPOSAL_FAILED,
  UPDATE_INNER_COMMERCIAL_PROPOSAL,
  UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED,
  ADD_COMMERCIAL_PROPOSAL_FAILED,
  ADD_COMMERCIAL_QUOTE_FULFILLED,
  ADD_COMMERCIAL_QUOTE_REJECTED,
  ADD_COMMERCIAL_QUOTE_REQUESTED,
  ADD_INNER_COMMERCIAL_PROPOSAL,
  ADD_INNER_COMMERCIAL_PROPOSAL_FAILED,
  RESET_PROPOSAL,
  GET_COMMERCIAL_PROPOSAL,
  GET_COMMERCIAL_PROPOSAL_FAILED,
  GET_PROPOSAL_SUCCESSFULLY,
  GET_PROPOSAL_FAILED
} from './types';

export const addCommercialQuote = (quoteData) => (dispatch) => {
  dispatch(addCommercialQuoteRequested());

  axiosInstance.post('/commercial-quote/', quoteData)
    .then(response => {
      dispatch(addCommercialQuoteFulfilled(response.data))
    }
    )
    .catch(error => {
      dispatch(addCommercialQuoteRejected(error?.response?.data || 'Something went wrong'))
    })
}

function addCommercialQuoteRequested() {
  return { type: ADD_COMMERCIAL_QUOTE_REQUESTED }
}

function addCommercialQuoteFulfilled(data) {
  return { type: ADD_COMMERCIAL_QUOTE_FULFILLED, payload: data }
}

function addCommercialQuoteRejected(error) {
  return { type: ADD_COMMERCIAL_QUOTE_REJECTED, payload: error }
}

// Update commercial quote
export const updateCommercialQuote = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/commercial-quote/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_COMMERCIAL_QUOTE,
          payload: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_COMMERCIAL_QUOTE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Get commercial proposal
export const getCommercialProposal = (commercial_quote_uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/commercial-proposal/?commercial_quote__uuid=${commercial_quote_uuid}`,)
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_PROPOSAL,
          payload: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_PROPOSAL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Add commercial Proposal
export const addCommercialProposal = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/commercial-proposal/`, params)
      .then((response) => {
        dispatch({
          type: ADD_COMMERCIAL_PROPOSAL,
          payload: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_COMMERCIAL_PROPOSAL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Update commercial Proposal
export const updateCommercialProposal = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/commercial-proposal/${uuid}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_COMMERCIAL_PROPOSAL,
          payload: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_COMMERCIAL_PROPOSAL_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Add Inner commercial Proposal
export const addInnerCommercialProposal = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/inner-proposal/`,params)
      .then((response) => {
        dispatch({
          type: ADD_INNER_COMMERCIAL_PROPOSAL,
          payload: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: ADD_INNER_COMMERCIAL_PROPOSAL_FAILED,
            payload: error?.response?.data,
          });
        }
      });
  };
};

// Update Inner commercial Proposal
export const updateInnerCommercialProposal = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/inner-proposal/${uuid}/`,params)
      .then((response) => {
        dispatch({
          type: UPDATE_INNER_COMMERCIAL_PROPOSAL,
          payload: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED,
            payload: error?.response?.data,
          });
        }
      });
  };
};

// reset Proposal
export const resetProposal = () => {
  return (dispatch) => {
    dispatch({type: RESET_PROPOSAL});
  };
};

// Get a single Quote
export const getQuoteById = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/commerical-crm/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_PROPOSAL_SUCCESSFULLY,
          payload: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PROPOSAL_FAILED,
              payload: error.response.data,
            });
          }
        }
      });
  };
};